module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/promo/2/8-9d32e3ca286ace9e2a98662b077cb4fd.png";